export default {
  buttons: {
    send_code: 'Enviar código de acceso',
  },
  placeholders: {
    mobile_number: 'Número de móvil',
    email: 'Correo electrónico',
  },
  feedback: {
    phone_number_required: 'Por favor, introduce tu número de teléfono',
    email_required: 'Introduce tu correo electrónico',
  },
};
